/* tslint:disable */
/* eslint-disable */
/**
 * Seamworks API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApplicationConfigurationDto } from '../model/';
// @ts-ignore
import type { RemoteServiceErrorResponse } from '../model/';
/**
 * AbpApplicationConfigurationApi - axios parameter creator
 * @export
 */
export const AbpApplicationConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {boolean} [includeLocalizationResources] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAbpApplicationConfigurationGet: async (includeLocalizationResources?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/abp/application-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (includeLocalizationResources !== undefined) {
                localVarQueryParameter['IncludeLocalizationResources'] = includeLocalizationResources;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AbpApplicationConfigurationApi - functional programming interface
 * @export
 */
export const AbpApplicationConfigurationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AbpApplicationConfigurationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {boolean} [includeLocalizationResources] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAbpApplicationConfigurationGet(includeLocalizationResources?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAbpApplicationConfigurationGet(includeLocalizationResources, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AbpApplicationConfigurationApi.apiAbpApplicationConfigurationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AbpApplicationConfigurationApi - factory interface
 * @export
 */
export const AbpApplicationConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AbpApplicationConfigurationApiFp(configuration)
    return {
        /**
         * 
         * @param {boolean} [includeLocalizationResources] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAbpApplicationConfigurationGet(includeLocalizationResources?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ApplicationConfigurationDto> {
            return localVarFp.apiAbpApplicationConfigurationGet(includeLocalizationResources, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AbpApplicationConfigurationApi - object-oriented interface
 * @export
 * @class AbpApplicationConfigurationApi
 * @extends {BaseAPI}
 */
export class AbpApplicationConfigurationApi extends BaseAPI {
    /**
     * 
     * @param {boolean} [includeLocalizationResources] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbpApplicationConfigurationApi
     */
    public apiAbpApplicationConfigurationGet(includeLocalizationResources?: boolean, options?: RawAxiosRequestConfig) {
        return AbpApplicationConfigurationApiFp(this.configuration).apiAbpApplicationConfigurationGet(includeLocalizationResources, options).then((request) => request(this.axios, this.basePath));
    }
}

